import { getProfilePresentation, getStudentGoal } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Work as WorkIcon,
} from '@material-ui/icons';
import HourglassHalf from 'components/Icons/HourglassHalf';
import Parcours from 'components/Icons/Parcours';
import DomainePro from 'components/Icons/DomainePro';
import { DonutSmall as DonutSmallIcon } from '@material-ui/icons';


const Criteria = ({ info }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { data: myGoal = [] } = useQuery(getStudentGoal, {
    key: ['myGoal', info?.id],
    variables: { id: info?.id },
  });

  const getLabel = (label) => {
    switch (label) {
      case 'Trouver un stage':
        return 'En recherche de stage';
      case 'Trouver une alternance':
        return "En recherche d'une alternance";
      case 'Trouver une formation':
        return "En recherche d'une formation";
      case 'Trouver une formation et un stage':
        return "En recherche d'une formation et d'un stage";
      case 'Trouver une formation et une alternance':
        return "En recherche d'une formation et d'une alternance";
      default:
        return 'Non renseigné';
    }
  };

  return (
    <div className={cx(classes.container)}>
      <div className={cx(global.title, classes.title)}>
        <FormattedMessage id="student.profil.criteria.title" />
      </div>
        <div className={css({ width: '100%' })}>
          <div className={cx(global.infoText, classes.address)}> <Parcours className={global.smallIcon} /> Parcours souhaité : <span className={classes.span}>{getLabel(myGoal.label) }</span></div>
        </div>
        <div className={css({ width: '100%' })}>
          <div className={cx(global.infoText, classes.address)}> <DonutSmallIcon className={global.smallIcon} />Domaine professionnel souhaité :<span className={classes.span}>{info?.jobDomain?.label || "Non renseigné" }</span></div>
        </div>
        <div className={css({ width: '100%' })}>
          <div className={cx(global.infoText, classes.address)}> <HourglassHalf className={global.smallIcon} /> Durée de contrat souhaitée :<span className={classes.span}>{info?.desiredContractLength ? info?.desiredContractLength + " mois" : "Non renseignée" }</span></div>
        </div>
        <div className={css({ width: '100%' })}>
          <div className={cx(global.infoText, classes.address)}> <WorkIcon className={global.smallIcon} /> Types de postes souhaités :<span className={classes.span}>{info?.jobs?.[0] ? <ul className={classes.listContainer}>{info.jobs.map(( item ) => <li>{item.label}</li>)}</ul> : "Non renseigné"}</span></div>
        </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    display: 'flex',
    padding: spacing(0, 2.5),
    flexDirection: 'column',
    marginTop: spacing(2.5),
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: spacing(1),
  },
  span: {
    color: '#152652',
    marginLeft: spacing(0.5),
  },
  title: {
    borderLeft: '3px solid #0060F9',
    lineHeight: '100%',
    paddingLeft: spacing(1),
    marginBottom: spacing(1.5)
  },
  listContainer: {
    margin: 0,
  },
});

Criteria.propTypes = {
  info: PropTypes.object,
};

export default Criteria;
